/**
         * @file Pricing Card Action
         * @description Client component to trigger checkout session.
         */
        'use client';

        import { useState } from 'react';
        import { Button } from "@/components/ui/button";
        import { createCheckoutSession } from "@/lib/actions/stripe";
        import { Loader2 } from "lucide-react";
        import { toast } from "sonner";

        interface PricingCardActionProps {
            tier: 'lite' | 'medium' | 'pro';
            label: string;
            highlighted: boolean;
            cycle: 'monthly' | 'annual';
        }

        export function PricingCardAction({ tier, label, highlighted, cycle }: PricingCardActionProps) {
            const [isLoading, setIsLoading] = useState(false);

            const handleCheckout = async () => {
                setIsLoading(true);
                try {
                    const result = await createCheckoutSession(tier, cycle);
                    if (result?.error) {
                        toast.error("Errore: " + result.error);
                        setIsLoading(false);
                    }
                    // If success, redirect happens on server
                } catch (error) {
                    toast.error("Errore imprevisto durante il checkout.");
                    setIsLoading(false);
                }
            };

            return (
                <Button 
                    onClick={handleCheckout}
                    disabled={isLoading}
                    variant={highlighted ? "default" : "outline"}
                    className={`w-full mb-8 h-12 text-lg font-bold ${
                        highlighted 
                        ? 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-lg shadow-indigo-200' 
                        : 'border-2 border-slate-300 hover:border-slate-400 text-slate-700'
                    }`}
                >
                    {isLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : label}
                </Button>
            );
        }